import React from 'react';
import CardFace from './CardFace';
import CardBack from './CardBack';

function Card({ card, faceUp, size = 'normal', selected, onClick, disabled }) {
  const sizeClass = size === 'small' ? 'card--small' : 'card--normal';
  const selectedClass = selected ? 'card--selected' : '';
  const disabledClass = disabled ? 'card--disabled' : '';

  return (
    <div
      className={`card ${sizeClass} ${selectedClass} ${disabledClass}`}
      onClick={disabled ? undefined : onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
    >
      {faceUp && card && card.rank !== 'HIDDEN' ? (
        <CardFace card={card} />
      ) : (
        <CardBack />
      )}
    </div>
  );
}

export default Card;
